import { EntitiesTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  //---------------
  EntitiesList: [],
  milestoneConfig: [],
  currentEntity: [],
  lengthEntities: 0,
  isLoading: false,
  error: {},
};

const Entities = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case EntitiesTypes.GET_ENTITIES_BY_TYPE:
      return {
        ...state,
        isLoading: true,
      };

    case EntitiesTypes.GET_ENTITIES_BY_TYPE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case EntitiesTypes.GET_ENTITIES_BY_TYPE_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    //-----------------------------------------------------------

    case EntitiesTypes.GET_ENTITIES_LIST:
      return {
        ...state,
        isLoading: true,
      };

    case EntitiesTypes.GET_ENTITIES_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        EntitiesList: action.payload.entitiesData,
        milestoneConfig: action.payload.milestoneConfig,
        lengthEntities: action.payload.CountItems,
      };

    case EntitiesTypes.GET_ENTITIES_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    //-----------------------------------------------------------

    case EntitiesTypes.GET_ENTITY:
      return {
        ...state,
        isLoading: true,
      };

    case EntitiesTypes.GET_ENTITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentEntity: action.payload.entity,
      };

    case EntitiesTypes.GET_ENTITY_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case EntitiesTypes.GET_ENTITY_RESET:
      return {
        ...state,
        isLoading: false,
        currentEntity: [],
      };

    default:
      return state;
  }
};

export default Entities;
